import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { endPoints } from '../utils/constants/endPoints';
import { queryKeys } from '../utils/constants/queryKeys';
import { PaymentField } from '../utils/models/PaymentField';

export function usePaymentField() {
  const qc = useQueryClient();

  return useMutation(
    async (data: PaymentField) => {
      const res = await $api.post(endPoints.PAYMENT_FIELD, data);

      return res.data;
    },
    {
      onSuccess: data => {
        showMessage(data.message, data.accept);
        qc.invalidateQueries([queryKeys.PAYMENT_FIELD]);
      },
      onError: baseErrorHandler
    }
  );
}
